var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2658 49.9998C12.074 49.9998 2.50222 41.8871 0.339878 30.1272C0.299514 29.9077 0.226562 29.4648 0.226562 29.4648L12.3072 29.4651C12.3072 29.4651 12.3866 29.7303 12.4289 29.8607C14.22 35.3809 19.0848 38.2354 24.2658 38.2354C29.4553 38.2354 34.3277 35.4311 36.1115 29.8698C36.1543 29.7364 36.2346 29.4649 36.2346 29.4649L48.305 29.4648C48.305 29.4648 48.2444 29.8351 48.2113 30.0188C46.088 41.8373 36.4949 49.9998 24.2658 49.9998Z",
    fill: "url(#paint0_linear_7469_269098)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2642 0C37.0162 0 46.9019 8.79472 48.4408 21.4966C48.4738 21.7696 48.5284 22.3211 48.5284 22.3211L36.6251 22.321C36.6251 22.321 36.5736 22.008 36.5446 21.8541C35.2832 15.1486 29.9651 11.7645 24.2642 11.7645C18.6285 11.7645 13.3668 15.0716 12.0286 21.6253C11.982 21.8533 11.9033 22.321 11.9033 22.321L0 22.3211C0 22.3211 0.0788874 21.5469 0.129772 21.1652C1.79913 8.642 11.6234 0 24.2642 0Z",
    fill: "url(#paint1_linear_7469_269098)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7469_269098",
    x1: 38.5455,
    y1: 29.4648,
    x2: 19.6276,
    y2: 54.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7469_269098",
    x1: 38.6775,
    y1: 0.00000184972,
    x2: 17.7727,
    y2: 25.2587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.76f09b14ea665d375c54267db13d1328.svg";
export { ForwardRef as ReactComponent };